import { render } from "./SideMenuRefObCom.vue?vue&type=template&id=43600011&scoped=true"
import script from "./SideMenuRefObCom.vue?vue&type=script&lang=js"
export * from "./SideMenuRefObCom.vue?vue&type=script&lang=js"

import "@/assets/process_steps.css?vue&type=style&index=0&id=43600011&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43600011"]])

export default __exports__